import { showAlertWithConfirm } from "../server/ShowAlert";

export const TAB_JWT_KEY = "hamazonTabJwtToken";

let driftHandled = false;

export const getStoredJwtToken = () => localStorage.getItem("jwtToken");

export const getTabJwtToken = () => sessionStorage.getItem(TAB_JWT_KEY);

export const markTabAuthToken = (token) => {
  const resolvedToken = token === undefined ? getStoredJwtToken() : token;

  if (resolvedToken) {
    sessionStorage.setItem(TAB_JWT_KEY, resolvedToken);
    return;
  }
  sessionStorage.removeItem(TAB_JWT_KEY);
};

export const hasAuthTokenDrift = () => getStoredJwtToken() !== getTabJwtToken();

export const handleAuthTokenDrift = ({
  onReload = () => window.location.reload(),
} = {}) => {
  if (driftHandled || !hasAuthTokenDrift()) {
    return false;
  }

  driftHandled = true;

  showAlertWithConfirm({
    msgTitle: "התחברות השתנתה",
    msgText:
      "בוצעה התחברות או יציאה בכרטיסיה אחרת. הדף יתרענן כדי לסנכרן את הנתונים.",
    confirmText: "רענון",
    msgType: "info",
    allowOutsideClick: false,
    allowEscapeKey: false,
    onConfirm: onReload,
  });

  return true;
};

export const resetAuthTokenDriftGuard = () => {
  driftHandled = false;
};
